export default __webpack_public_path__ + "static/media/9.8e48208f.png";